export const VERSION = "0.1"

export const ROLES = {
    'user_geolocalisation' : 'Utilisateur Géolocalisation',
    'admin' : 'Administrateur',
    'user_portal': 'Utilisateur Portail Bus Elec'
}

export const MANUFACTURING_SITE = {
    coord : {
        lat: 46.90299323764274,
        lng: -0.6920310981106956
    }
}
